import { render, staticRenderFns } from "./accommodations.vue?vue&type=template&id=24ed3396"
import script from "./accommodations.vue?vue&type=script&lang=js"
export * from "./accommodations.vue?vue&type=script&lang=js"
import style0 from "./accommodations.vue?vue&type=style&index=0&id=24ed3396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports